import { Component } from "react";
import PillLabel from "../../../../components/PillLabel";
import SelectQuickbooksEntity from "./SelectQuickbooksEntity";
import { Button, CircularProgress, ClickAwayListener, IconButton } from "@mui/material";
import { Check, Close, Edit } from "@mui/icons-material";
import { errorToast } from "../../../../toast";
import request from "../../../../request";
import swal from "sweetalert";


export default class QuickbooksEntity extends Component {

   state = {
      showingAccountsSelector: false,
      selectedAccount: null,
      loading: false,
   }

   showAccountsSelector = () => {
      this.setState({ showingAccountsSelector: true })
   }

   hideIncomeAccountsSelector = () => {
      this.setState({ showingAccountsSelector: false });
   }

   save = async () => {

      const account = this.state.selectedAccount;
		if (!account) {
			errorToast('Please select an account');
			return;
		}

		try {
			
			this.setState({ loading: true });

         const url = `/api/finance/quickbooks/${this.props.putPath}`;

			await request.put(url, {
				id: account.id,
				name: account.name,
			});

			this.hideIncomeAccountsSelector();
         this.props.onChange(account);

		} catch (err) {
			swal("Error", err.message, 'error');
		} finally {
			this.setState({ loading: false });
		}
	}

   render() {

      let jsx;
      const title = this.props.title;
      const disabled = this.props.disabled || this.state.loading;

      if (this.state.showingAccountsSelector) {

         let actions;

         if (this.state.loading) {
            actions = <CircularProgress
               size={24}
            />
         } else {
            actions = <>
               <IconButton onClick={this.save} color="primary">
                  <Check />
               </IconButton>
               <IconButton onClick={() => this.hideIncomeAccountsSelector()} color="error">
                  <Close  />
               </IconButton>
            </>
         }

         const selectAccountFetchUrl = `/api/general/quickbooks/${this.props.getListPath}`;

         jsx = <div className="grid grid-cols-[1fr,auto] gap-1 mt-4">
            <SelectQuickbooksEntity
               label={title}
               onChange={selectedAccount => {
                  this.setState({ selectedAccount });
               }}
               value={this.state.selectedAccount}
               disabled={disabled}
               flattenItems={this.props.hasHierarchy}
               fetchUrl={selectAccountFetchUrl}
               itemType={this.props.type || this.props.title}
            />
            <div className="flex items-center">
               {actions}
            </div>
         </div>
      } else {
         jsx = this.props.value ? <div className="px-2">
            <div className="inline-block text-blue-500 font-bold">
               {this.props.value.name}
            </div>
            <IconButton
               onClick={() => this.showAccountsSelector(this.props.value)}
               size="small"
               disabled={disabled}
            >
               <Edit fontSize="small" />
            </IconButton>
         </div> : <>
            <Button variant="contained" size="small" className="rounded-full px-2 py-1" onClick={this.showAccountsSelector} disabled={disabled}>
               Set
            </Button>
         </>
      }

      return <ClickAwayListener onClickAway={this.hideIncomeAccountsSelector}>
         <div className="text-xs py-2">
            <PillLabel>{title}</PillLabel>
            <div className="mt-2">
               {this.props.description}
               <div className="mt-2">
                  {jsx}
               </div>
            </div>
         </div>
      </ClickAwayListener>
   }
}